import React, { useEffect } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

const variants = {
  success: {
    bg: 'bg-green-600',
    icon: '✅',
  },
  error: {
    bg: 'bg-red-600',
    icon: '❌',
  },
  warning: {
    bg: 'bg-yellow-600',
    icon: '⚠️',
  },
  info: {
    bg: 'bg-blue-600',
    icon: 'ℹ️',
  },
};

const Toast = ({ type = 'info', message, onClose, duration = 3000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose?.();
    }, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const { bg, icon } = variants[type] || variants.info;

  return (
    <div className={`fixed top-6 right-6 z-50 shadow-lg rounded-lg text-white px-6 py-4 flex items-center space-x-4 ${bg}`}>
      <span className="text-2xl">{icon}</span>
      <span className="text-sm font-medium">{message}</span>
      <button onClick={onClose}>
        <XMarkIcon className="w-5 h-5 text-white hover:text-gray-200 transition" />
      </button>
    </div>
  );
};

export default Toast;
